export default "__VITE_ASSET__PsBCsEfX__"